var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"banner"}),_c('div',{staticClass:"content"},[_c('keep-alive',[_c('router-view')],1)],1),_c('BottomTabBar',{attrs:{"tabs":_vm.tabs,"themeColor":_vm.themeColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }